<script lang="ts">
	import { getContext } from 'svelte';

	import Notification from './Notification.svelte';
	import NotificationProvider from './store.svelte';

	const notificationProvider = getContext<NotificationProvider>('notification');
</script>

{#each notificationProvider.notifications as notification, i (i)}
	<Notification {...notification} class="full-container mx-auto p-4 xl:mx-auto" />
{/each}
